import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Download, Film, Image as ImageIcon, Leaf } from 'lucide-react';
import { Button } from '../components/ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const LABELS = {
  'ig-square-ai-scan.jpg': 'AI Skin Scan — Instagram/Facebook square',
  'ig-square-cycle.jpg': 'Cycle Prediction — Instagram/Facebook square',
  'story-detox-score.jpg': 'Detox Score — Story / TikTok vertical',
  'story-before-after.jpg': 'Before & After — Story / TikTok vertical',
  'fb-banner.jpg': 'Clear Skin Banner — Facebook/X landscape',
  'innerglow-promo-square.mp4': 'Promo Video — square feed (13s)',
  'innerglow-promo-story.mp4': 'Promo Video — Story/TikTok vertical (10s)',
};

export default function PromoKit() {
  const [files, setFiles] = useState([]);

  useEffect(() => {
    axios.get(`${API}/promo/list`).then((r) => setFiles(r.data)).catch(() => {});
  }, []);

  const videos = files.filter((f) => f.endsWith('.mp4'));
  const images = files.filter((f) => !f.endsWith('.mp4'));

  return (
    <div className="min-h-screen bg-[#FFF2EC] px-6 py-10" data-testid="promo-kit-page">
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center gap-2 mb-2">
          <Leaf className="w-7 h-7 text-[#FF6B4A]" />
          <h1 className="font-heading text-2xl font-bold text-[#1A1514]">InnerGlow Promo Kit</h1>
        </div>
        <p className="text-sm text-[#8C7A76] mb-8">Tap Download on any asset — it saves straight to your device (on iPhone, check the Files app or your Downloads).</p>

        <h2 className="font-heading text-lg font-bold text-[#1A1514] mb-3 flex items-center gap-2"><Film className="w-5 h-5 text-[#A388EE]" /> Videos</h2>
        <div className="space-y-4 mb-10">
          {videos.map((f) => (
            <div key={f} className="bg-white rounded-2xl p-4 border border-[#E5D0C9]" data-testid={`promo-video-${f}`}>
              <video src={`/promo/${f}`} controls playsInline preload="metadata" className="w-full max-h-96 rounded-xl mb-3 bg-black" />
              <div className="flex items-center justify-between gap-3 flex-wrap">
                <p className="text-sm font-semibold text-[#1A1514]">{LABELS[f] || f}</p>
                <a href={`${API}/promo/download/${f}`} download={f} data-testid={`download-${f}`}>
                  <Button className="bg-[#FF6B4A] hover:bg-[#E8552F] text-white rounded-full font-semibold">
                    <Download className="w-4 h-4 mr-2" /> Download
                  </Button>
                </a>
              </div>
            </div>
          ))}
        </div>

        <h2 className="font-heading text-lg font-bold text-[#1A1514] mb-3 flex items-center gap-2"><ImageIcon className="w-5 h-5 text-[#4ADE80]" /> Images</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {images.map((f) => (
            <div key={f} className="bg-white rounded-2xl p-3 border border-[#E5D0C9]" data-testid={`promo-image-${f}`}>
              <img src={`/promo/${f}`} alt={LABELS[f] || f} className="w-full rounded-xl mb-3" loading="lazy" />
              <div className="flex items-center justify-between gap-2">
                <p className="text-xs font-semibold text-[#1A1514] flex-1">{LABELS[f] || f}</p>
                <a href={`${API}/promo/download/${f}`} download={f} data-testid={`download-${f}`}>
                  <Button size="sm" variant="outline" className="border-[#FF6B4A] text-[#FF6B4A] hover:bg-[#FF6B4A]/5 rounded-full font-semibold">
                    <Download className="w-3.5 h-3.5 mr-1.5" /> Download
                  </Button>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
